/* ==========================================================================
   PH VARIANT MEDIA (2026-10) - Phillips House
   1) Product pages: when the selected variant has no photograph of its own, return the
      gallery to the yellow-gold fallback image (rendered by snippets/product-gallery.liquid
      as the "ph-fallback-media-id" attribute). Purchasing data (variant id, SKU, price) is
      untouched: this only moves the gallery.
   2) Collection cards: hover preview for Kumihimo photographic silk-color thumbnails.
   Remove this file and its include in layout/theme.liquid to revert.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. Yellow-gold fallback on variant change ---------- */
  function selectFallback(gallery) {
    var id = gallery.getAttribute('ph-fallback-media-id');
    if (!id) return;
    var cell = gallery.querySelector('.product-gallery__media[data-media-id="' + id + '"]');
    if (!cell || cell.hidden) return;

    var carousel = gallery.querySelector('scroll-carousel');
    if (carousel && carousel.isScrollable && typeof carousel.select === 'function') {
      var visible = Array.prototype.filter.call(
        carousel.querySelectorAll('.product-gallery__media'),
        function (el) { return !el.hidden; }
      );
      var index = visible.indexOf(cell);
      if (index >= 0) carousel.select(index, { instant: true });
    } else {
      // Desktop grid layout: same behavior as the theme for photographed variants
      var rect = cell.getBoundingClientRect();
      var inView = rect.top >= 0 && rect.top < window.innerHeight * 0.5;
      if (!inView) cell.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  /* Desktop grid: the selected variant's photo (or the yellow-gold fallback) is shown first, so shared
     photos such as the model photo follow it */
  function markFirst(gallery, mediaId) {
    var cell = mediaId
      ? gallery.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]')
      : gallery.querySelector('.product-gallery__media.is-initial');
    if (!cell) return null;
    Array.prototype.forEach.call(gallery.querySelectorAll('.ph-is-first'), function (el) { el.classList.remove('ph-is-first'); });
    cell.classList.add('ph-is-first');
    return cell;
  }

  document.querySelectorAll('product-gallery').forEach(function (gallery) { markFirst(gallery); });

  function formIdOf(target, detail) {
    if (detail && typeof detail.formId === 'string') return detail.formId;
    // Note: form.id can be shadowed by the form's <input name="id">, so read the attribute
    return target && target.getAttribute ? target.getAttribute('id') : null;
  }

  // product:rerender (does not bubble, so listen in the capture phase) fires before the theme moves the
  // gallery. Putting the newly selected photo first here means the theme's own scroll lands on it.
  document.addEventListener('product:rerender', function (event) {
    var formId = formIdOf(event.target);
    var fragment = event.detail && event.detail.htmlFragment;
    if (!formId || !fragment || (event.detail && event.detail.productChange)) return;
    var galleries = document.querySelectorAll('product-gallery[form="' + formId + '"]');
    if (!galleries.length) return;
    var json = fragment.querySelector('variant-picker[form-id="' + formId + '"] script[data-variant]');
    var newVariant = null;
    try { newVariant = json ? JSON.parse(json.textContent) : null; } catch (e) { newVariant = null; }
    if (!newVariant) return;
    galleries.forEach(function (gallery) {
      var mediaId = newVariant.featured_media ? newVariant.featured_media.id : gallery.getAttribute('ph-fallback-media-id');
      if (mediaId) markFirst(gallery, mediaId);
    });
  }, true);

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || variant.featured_media) return; // the theme already shows variants that have their own photo

    var formId = formIdOf(event.target, detail);
    if (!formId) return;

    // Run after the theme's own handlers (gallery filtering happens on product:rerender)
    setTimeout(function () {
      document.querySelectorAll('product-gallery[form="' + formId + '"]').forEach(selectFallback);
    }, 0);
  });

  /* ---------- 2. Collection card silk-color hover preview ---------- */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function cardParts(el) {
    var card = el.closest('product-card');
    if (!card) return null;
    return {
      card: card,
      img: card.querySelector('.product-card__image--primary'),
      name: card.querySelector('[data-ph-silk-name]')
    };
  }

  function preview(thumb) {
    var p = cardParts(thumb);
    if (!p || !p.img) return;
    if (!p.img.hasAttribute('data-ph-original-src')) {
      p.img.setAttribute('data-ph-original-src', p.img.getAttribute('src') || '');
      p.img.setAttribute('data-ph-original-srcset', p.img.getAttribute('srcset') || '');
    }
    if (thumb.dataset.phPreviewSrcset) p.img.setAttribute('srcset', thumb.dataset.phPreviewSrcset);
    if (thumb.dataset.phPreviewSrc) p.img.setAttribute('src', thumb.dataset.phPreviewSrc);
    if (p.name && thumb.dataset.phColor) p.name.textContent = thumb.dataset.phColor;
  }

  function restore(container) {
    var p = cardParts(container);
    if (!p) return;
    if (p.img && p.img.hasAttribute('data-ph-original-src')) {
      var srcset = p.img.getAttribute('data-ph-original-srcset');
      if (srcset) p.img.setAttribute('srcset', srcset); else p.img.removeAttribute('srcset');
      p.img.setAttribute('src', p.img.getAttribute('data-ph-original-src'));
    }
    if (p.name) p.name.textContent = p.name.getAttribute('data-ph-current') || '';
  }

  if (canHover) {
    document.addEventListener('pointerover', function (e) {
      var thumb = e.target.closest && e.target.closest('.ph-silk-thumb');
      if (thumb && e.pointerType === 'mouse') preview(thumb);
    });
    document.addEventListener('pointerout', function (e) {
      var box = e.target.closest && e.target.closest('[data-ph-silk-thumbs]');
      if (box && !box.contains(e.relatedTarget)) restore(box);
    });
  }

  document.addEventListener('focusin', function (e) {
    var thumb = e.target.closest && e.target.closest('.ph-silk-thumb');
    if (thumb) preview(thumb);
  });
  document.addEventListener('focusout', function (e) {
    var box = e.target.closest && e.target.closest('[data-ph-silk-thumbs]');
    if (box && !box.contains(e.relatedTarget)) restore(box);
  });
})();
